import { CSSProperties } from 'react';
import { DefaultTheme } from '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useGroupByScrollbarStyles = makeStyles((theme) => ({
  scrollbar: {
    ...getScrollStyles(theme)
  }
}));

export const getScrollStyles = (
  theme: DefaultTheme
): Record<string, CSSProperties | string> => ({
  '&::-webkit-scrollbar': {
    width: theme.spacing(0.75)
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.grey[600]
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.common.black
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: theme.palette.grey[600],
    borderRight: '2px solid transparent',
    borderLeft: '2px solid transparent',
    backgroundClip: 'padding-box'
  },
  'scrollbar-width': 'auto'
});
